/**
 * VisitClinicSchedulePage — 施術入力 (来院) 初期画面.
 * A2/R2 サービス対応 (visit_clinic/schedule に対応).
 *
 * 画面構成:
 *   - 受診者氏名 テキスト入力 + 検索 ボタン  (施術年月なし)
 *   - 検索 クリック → VisitClinicPatientSearchModal を開く
 */

import React, { useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import VisitClinicSearchBar from '@/components/organisms/VisitClinicCalendar/VisitClinicSearchBar';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/shared/providers/AuthContext';
import { useTheme } from '@/shared/providers/theme/ThemeContext';
import { getYearmonthSearch } from '@/services/main/visitClinic';
import { isoMonthToJaWareki } from '@/utils/dateConverter';

const VisitClinicSchedulePage: React.FC = () => {
  const navigate = useNavigate();
  const { tenant } = useParams<{ tenant: string }>();
  const [searchParams] = useSearchParams();
  const { clinic } = useAuth();
  const { serviceType } = useTheme();
  const autoNavigatedRef = useRef(false);

  // Auto-navigate to edit page when patient_id is provided via query params
  useEffect(() => {
    if (autoNavigatedRef.current) return;
    const patientId = searchParams.get('patient_id');
    if (!patientId || !clinic?.site_type || !clinic?.clinic_number) return;
    autoNavigatedRef.current = true;
    const pid = parseInt(patientId, 10);
    if (!Number.isInteger(pid)) return;
    getYearmonthSearch(clinic.site_type, clinic.clinic_number, pid, serviceType)
      .then(({ yearmonth: ym }) => {
        const jaYearmonth = isoMonthToJaWareki(ym);
        navigate(`/${tenant}/visit_clinic/edit/${pid}/${jaYearmonth}`, { replace: true });
      })
      .catch(() => {
        const jaYearmonth = isoMonthToJaWareki(dayjs().format('YYYY-MM'));
        navigate(`/${tenant}/visit_clinic/edit/${pid}/${jaYearmonth}`, { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinic?.site_type, clinic?.clinic_number, serviceType]);

  return <VisitClinicSearchBar />;
};

export default VisitClinicSchedulePage;
